.pds-tooltip {
  --tooltip-border-width-arrow-down: var(--tooltip-sizing-arrow) var(--tooltip-sizing-arrow) 0;
  --tooltip-border-width-arrow-left: var(--tooltip-sizing-arrow) var(--tooltip-sizing-arrow) var(--tooltip-sizing-arrow) 0;
  --tooltip-border-width-arrow-right: var(--tooltip-sizing-arrow) 0 var(--tooltip-sizing-arrow) var(--tooltip-sizing-arrow);
  --tooltip-border-width-arrow-up: 0 var(--tooltip-sizing-arrow) var(--tooltip-sizing-arrow);
  --tooltip-sizing-arrow: 6px;
  --tooltip-sizing-arrow-offset: 14px;
  --tooltip-dimension-max-width: 320px;
}

.pds-tooltip__content {
  background-color: var(--pine-color-primary);
  border-radius: calc(var(--pine-dimension-xs) * 1.25);
  box-shadow: var(--pine-box-shadow);
  color: var(--pine-color-text-primary);
  // TODO: need to use block / none but the tooltip content width and height are needed for calculations
  max-width: var(--tooltip-dimension-max-width);
  opacity: 0;
  padding: var(--pine-dimension-xs) calc(var(--pine-dimension-md) / 2);
  position: relative;
  visibility: hidden;
  width: max-content;

  .pds-tooltip--is-open & {
    // TODO: need to use block / none but the tooltip content width and height are needed for calculations
    opacity: 1;
    visibility: visible;
    z-index: var(--pine-z-index-raised);
  }

  .pds-tooltip.pds-tooltip--has-html-content & {
    width: fit-content;
  }

  &::after {
    border-color: transparent;
    border-right-color: transparent;
    border-style: solid;
    border-width: var(--tooltip-border-width-arrow-left);
    content: '';
    height: 0;
    position: absolute;
    width: 0;

    // Arrow placement uses physical left/right to match Floating UI placement names.
    .pds-tooltip--right & {
      border-inline-end-color: var(--pine-color-primary);
      border-width: var(--tooltip-border-width-arrow-left);
      left: calc(var(--tooltip-sizing-arrow) * -1);
      top: 50%;
      transform: translateY(-50%);
    }

    .pds-tooltip--right-end & {
      border-inline-end-color: var(--pine-color-primary);
      border-width: var(--tooltip-border-width-arrow-left);
      bottom: var(--tooltip-sizing-arrow-offset);
      left: calc(var(--tooltip-sizing-arrow) * -1);
      top: initial;
    }

    .pds-tooltip--right-start & {
      border-inline-end-color: var(--pine-color-primary);
      border-width: var(--tooltip-border-width-arrow-left);
      left: calc(var(--tooltip-sizing-arrow) * -1);
      top: var(--tooltip-sizing-arrow-offset);
    }

    .pds-tooltip--top & {
      border-block-start-color: var(--pine-color-primary);
      border-width: var(--tooltip-border-width-arrow-down);
      bottom: calc(var(--tooltip-sizing-arrow) * -1);
      left: 50%;
      top: initial;
      transform: translateX(-50%);
    }

    .pds-tooltip--top-start & {
      border-block-start-color: var(--pine-color-primary);
      border-width: var(--tooltip-border-width-arrow-down);
      bottom: calc(var(--tooltip-sizing-arrow) * -1);
      left: var(--tooltip-sizing-arrow-offset);
      top: initial;
    }

    .pds-tooltip--top-end & {
      border-block-start-color: var(--pine-color-primary);
      border-width: var(--tooltip-border-width-arrow-down);
      bottom: calc(var(--tooltip-sizing-arrow) * -1);
      left: initial;
      right: var(--tooltip-sizing-arrow-offset);
      top: initial;
    }

    .pds-tooltip--left & {
      border-inline-start-color: var(--pine-color-primary);
      border-width: var(--tooltip-border-width-arrow-right);
      left: initial;
      right: calc(var(--tooltip-sizing-arrow) * -1);
      top: 50%;
      transform: translateY(-50%);
    }

    .pds-tooltip--left-end & {
      border-inline-start-color: var(--pine-color-primary);
      border-width: var(--tooltip-border-width-arrow-right);
      bottom: var(--tooltip-sizing-arrow-offset);
      left: initial;
      right: calc(var(--tooltip-sizing-arrow) * -1);
      top: initial;
    }

    .pds-tooltip--left-start & {
      border-inline-start-color: var(--pine-color-primary);
      border-width: var(--tooltip-border-width-arrow-right);
      left: initial;
      right: calc(var(--tooltip-sizing-arrow) * -1);
      top: var(--tooltip-sizing-arrow-offset);
    }

    .pds-tooltip--bottom & {
      border-block-end-color: var(--pine-color-primary);
      border-width: var(--tooltip-border-width-arrow-up);
      left: 50%;
      top: calc(var(--tooltip-sizing-arrow) * -1);
      transform: translateX(-50%);
    }

    .pds-tooltip--bottom-end & {
      border-block-end-color: var(--pine-color-primary);
      border-width: var(--tooltip-border-width-arrow-up);
      left: initial;
      right: var(--tooltip-sizing-arrow-offset);
      top: calc(var(--tooltip-sizing-arrow) * -1);
    }

    .pds-tooltip--bottom-start & {
      border-block-end-color: var(--pine-color-primary);
      border-width: var(--tooltip-border-width-arrow-up);
      left: var(--tooltip-sizing-arrow-offset);
      top: calc(var(--tooltip-sizing-arrow) * -1);
    }

    .pds-tooltip--no-arrow & {
      border-width: 0;
    }
  }
}
